import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-brand-favicon',
  imports: [],
  templateUrl: './brand-favicon.component.html',
  styleUrl: './brand-favicon.component.scss'
})

export class BrandFaviconComponent {
@Input() domain: string = ''

  onImgError(event: Event) {
  const imgElement = event.target as HTMLImageElement;
  imgElement.src = 'images/no-logo.png';
  }
}
